// AUTO GENERATED FILE - Changes WILL be lost.
// ja - used as 'ja' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "ベットスリップ",
  "last60.fixture": "{visitor} {'@'} {home}",
  "last60.fixtureResult": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture": "{home} VS. {away}",
  "sb.fixtureResult": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "ベットを賭ける",
  "betslip.clear": "クリア",
  "betslip.clearResult": "すべてクリア",
  "betslip.noSelections": "選択してから、ベットが賭けられます",
  "betslip.notLoggedIn": "ログインしてベットを始めましょう",
  "betslip.refresh": "更新",
  "betslip.totalStake": "合計賭け金額",
  "betslip.noHistoryData": "ベット詳細なし",
  "betslip.openBets": "オープンベット",
  "betslip.betHistory": "ベット歴",
  "betslip.betHistoryWon": "勝",
  "betslip.betHistoryLost": "負",
  "loading.loading": "ロード中",
  "loading.account": "アカウント・ロード中",
  "loading.league": "リーグ・ロード中",
  "loading.gameweeks": "ゲームウィーク・ロード中",
  "loading.markets": "マーケット・ロード中",
  "loading.bethistory": "ベット歴ロード中",
  "login.loginRequired": "ログインが必要です",
  "login.loginToBet": "ログインしてベットを始めましょう",
  "navigation.back": "戻る",
  "navigation.close": "閉じる",
  "video.liveStreamAvailable": "ライブストリーミング",
  "video.logInToWatch": "ログインしてください",
  "error.error": "エラー達成",
  "error.404": "ページが見つかりません",
  "error.gameLaunchFailed": "ゲームを始められません",
  "error.unknownErrorCode": "不明なエラー：{code}",
  "error.minUnitStakeLimitExceeded": "最小ベット額は{limit}です",
  "error.maxUnitStakeLimitExceeded": "最大ベット額は{limit}です",
  "error.minTotalStakeLimitExceeded": "最小合計ベット額は{limit}です",
  "error.maxTotalStakeLimitExceeded": "最大合計ベット額は{limit}です",
  "error.notPlaced": "ベットがありません。",
  "error.wagerDisallowed": "ベット出来ません",
  "error.errorEventIsOff": "イベントが始まっています",
  "multiplebet.Singles": "シングル",
  "multiplebet.Doubles": "ダブル",
  "multiplebet.Trebles": "トレブル",
  "multiplebet.Accumulator": "パーレイ",
  "multiplebet.Perm 4-Folds": "4フォールド",
  "multiplebet.Perm 5-Folds": "5フォールド",
  "multiplebet.Perm 6-Folds": "6フォールド",
  "multiplebet.Perm 7-Folds": "7フォールド",
  "multiplebet.Perm 8-Folds": "8フォールド",
  "multiplebet.Perm 9-Folds": "9フォールド",
  "sb-english.team.ARS": "アーセナル",
  "sb-english.team.AST": "アストンV",
  "sb-english.team.BHA": "ブライトン",
  "sb-english.team.BOU": "ボーンマス",
  "sb-english.team.BUR": "バーンレー",
  "sb-english.team.CHE": "チェルシー",
  "sb-english.team.CRY": "Cパレス",
  "sb-english.team.EVE": "エバートン",
  "sb-english.team.LEI": "レスター",
  "sb-english.team.LIV": "リバーブール",
  "sb-english.team.MNC": "マンチェスターC",
  "sb-english.team.MNU": "マンチェスターU",
  "sb-english.team.NEW": "ニューカッスル",
  "sb-english.team.SOU": "サウスハンプトン",
  "sb-english.team.TOT": "トッテンハム",
  "sb-english.team.WAT": "ワトフォード",
  "sb-english.team.WHU": "ウェストハム",
  "sb-english.team.WOL": "ウルヴズ",
  "sb-english.team.NOR": "ノーウィッチ",
  "sb-english.team.SHU": "シェフィールドU",
  "sb-english.team.LEE": "リーズ",
  "sb-english.team.FUL": "フラム",
  "sb-english.team.WBA": "ウェスト・ブロム",
  "nomorebets": "賭け時間終了",
  "playtime": "プレー時間",
  "gameId": "ゲームID",
  "noGames": "ご利用可能なゲームがありません。 暫くしてから再度、確認してください。",
  "Home": "ホーム",
  "Away": "アウェイ",
  "Visitor": "ビジター",
  "soccerbet.gameWeek": "ゲームウィーク",
  "soccerbet.noGameWeeks": "ゲームウィーク終了しました",
  "soccerbet.league": "リーグ順位表",
  "soccerbet.table.name": "名",
  "soccerbet.table.won": "勝",
  "soccerbet.table.drawn": "引",
  "soccerbet.table.lost": "負",
  "soccerbet.table.points": "得点",
  "market.abbr.Both Teams To Score": "両チームゴール",
  "market.Both Teams To Score": "両チームゴール",
  "market.Over / Under": "オーバー・アンダー",
  "market.Double Chance": "ダブルチャンス",
  "market.Match Result": "試合結果",
  "market.Exact Goals": "ゴール数",
  "market.Correct Score": "コレクトスコア",
  "market.Match Result Both Score": "試合結果・両チームゴール",
  "market.Result Und/Over 1.5 Total Goals": "試合結果・オーバーアンダー1.5ゴール",
  "market.Result Und/Over 2.5 Total Goals": "試合結果・オーバーアンダー２.5ゴール",
  "market.Under Over 1.5 Total Goals": "オーバーアンダー1.5ゴール",
  "market.Under Over 2.5 Total Goals": "オーバーアンダー2.5ゴール",
  "market.Under Over 3.5 Total Goals": "オーバーアンダー3.5ゴール",
  "market.Under Over 4.5 Total Goals": "オーバーアンダー４.5ゴール",
  "market.Total Goals 1 To 2": "1-2ゴール",
  "market.Total Goals 1 To 3": "1-3ゴール",
  "market.Total Goals 1 To 4": "1-4ゴール",
  "market.Total Goals 2 To 3": "2-3ゴール",
  "market.Total Goals 2 To 4": "2-4ゴール",
  "market.Under Over 1.5 Home Goals": "ホーム・オーバーアンダー1.5ゴール",
  "market.Under Over 1.5 Away Goals": "アウェー・オーバーアンダー1.5ゴール",
  "market.Home Team Exact Goals": "ホームゴール数",
  "market.Away Team Exact Goals": "アウェーゴール数",
  "selection.Yes": "はい",
  "selection.No": "いーえ",
  "selection.1+G": "1+ゴール",
  "selection.1+Ng": "1+ノーゴール",
  "selection.X+G": "X+ゴール",
  "selection.X+Ng": "X+ノーゴール",
  "selection.2+G": "2+ゴール",
  "selection.2+Ng": "2+ノーゴール",
  "selection.1+Yes": "1+はい",
  "selection.1+No": "1+いーえ",
  "selection.X+Yes": "X+はい",
  "selection.X+No": "X+いーえ",
  "selection.2+Yes": "2+はい",
  "selection.2+No": "2+いーえ",
  "selection.TID_ANY_GOAL_SCORED_YES": "ゴール",
  "selection.TID_ANY_GOAL_SCORED_NO": "ノーゴール",
  "selection.U": "アンダー",
  "selection.O": "オーバー",
  "selection.1+O": "1+オーバー",
  "selection.X+O": "X+オーバー",
  "selection.2+O": "2+オーバー",
  "selection.1+U": "1+アンダー",
  "selection.X+U": "X+アンダー",
  "selection.2+U": "2+アンダー",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1x",
  "selection.TID_DRAW_OR_AWAY_WIN": "x2",
  "selection.TID_HOME_OR_AWAY_WIN": "12",
  "selection.Home": "{home}",
  "selection.Visitor": "{visitor}"
}
